import { render } from "./CreateOrder.vue?vue&type=template&id=b3e02b5e&scoped=true"
import script from "./CreateOrder.vue?vue&type=script&lang=js"
export * from "./CreateOrder.vue?vue&type=script&lang=js"

import "./CreateOrder.vue?vue&type=style&index=0&id=b3e02b5e&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b3e02b5e"]])

export default __exports__